import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class NavTabBarButton extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    SvgIcon: PropTypes.object.isRequired,
    className: PropTypes.string,
    divId: PropTypes.string,
    externalRef: PropTypes.func,
    tabIndex: PropTypes.number,
  };

  static defaultProps = {
    selected: false,
    className: null,
    divId: null,
    externalRef: null,
    onKeyDown: null,
    tabIndex: -1,
  };


  render() {
    const {
      divId, externalRef, title, description, selected, onClick, onKeyDown, SvgIcon, className, tabIndex,
    } = this.props;

    return (
      <div
        id={divId}
        ref={externalRef}
        role="tab"
        className={`${className} nav-tab-bar-button ${selected && 'nav-tab-bar-button--active'}`}
        onClick={onClick}
        onKeyDown={onKeyDown}
        tabIndex={tabIndex}
        aria-selected={selected}
      >

        <SvgIcon className={`nav-tab-bar-button__icon ${selected ? 'nav-tab-bar-button__icon--active' : ''}`} role="img" focusable="false" aria-hidden="true" />
        <span className="nav-tab-bar-button__title">{title}</span>
        <span className="nav-tab-bar-button__title nav-tab-bar-button__description">{description}</span>
      </div>
    );
  }
}

export default NavTabBarButton;